<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <v-sheet style="padding-bottom: 52px">
      <v-btn
        class="mt-1 float-right mr-1"
        @click="
          () => {
            this['User/fetchUsers']({ page: this.page });
            $router.push('/user');
          }
        "
        color="error"
        dark
        icon
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-list>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Name</v-list-item-title>
            <v-list-item-subtitle>{{ user.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Email Address</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Permissions</v-list-item-title>
            <v-list-item-subtitle>
              <ul style="max-height: 300px; overflow: auto;">
                <li v-for="permission in permissions" :key="permission.id">
                  <input
                    :id="'permission' + permission.id"
                    type="checkbox"
                    v-model="permissionChecked"
                    :value="permission.id"
                  />
                  <label :for="'permission' + permission.id">{{ permission.name }}</label>
                </li>
              </ul>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <span class="float-right mr-4" style="background-color: #fff">
        <v-btn @click="savePermissions" outlined color="green" class="mb-4">
          Save Permission
        </v-btn>
        <v-btn @click="deleteUser" outlined color="red" class="mb-4">
          Delete
        </v-btn>
        <v-btn @click="goToEdit" color="indigo" outlined class="mb-4">
          Edit
        </v-btn>
      </span>
    </v-sheet>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {
      permissionChecked: []
    };
  },
  components: {
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  beforeMount() {
    if (this.show) {
      this['User/getUser']({ id: this.$route.params.id }).finally(() => {
        if (this.user.name == '') {
          this.$router.push('/user');
        } else {
          this['Permission/fetchPermissions']();
          this['UserPermission/fetchPermissions']({ id: this.$route.params.id });
          this.updateCheckedPermissions();
        }
      });
    }
  },
  computed: {
    ...mapState({
      user(state) {
        if (typeof state.User.user.data == 'undefined') {
          return {
            name: '',
            email: ''
          };
        }
        this['UserPermission/fetchPermissions']({ id: this.$route.params.id });
        this.updateCheckedPermissions();
        return state.User.user.data;
      },
      permissions: state => state.Permission.permissions,
      user_permissions: state => state.UserPermission.permissions
    })
  },
  methods: {
    ...mapActions([
      'User/fetchUsers',
      'User/getUser',
      'Permission/fetchPermissions',
      'UserPermission/fetchPermissions'
    ]),
    updateCheckedPermissions() {
      this['UserPermission/fetchPermissions']({ user_id: this.$route.params.id }).finally(() => {
        this.permissionChecked = [];
        this.user_permissions.forEach(permission => {
          this.permissionChecked.push(permission.id);
        });
      });
    },
    savePermissions() {
      axios
        .post(`api/v1/user/${this.$route.params.id}/permission`, {
          user_permissions: this.permissionChecked
        })
        .then(response => {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Permission saved...',
            color: 'success'
          });
        });
    },
    deleteUser() {
      this.$refs.confirm
        .open('Delete User', 'Are you sure you want to delete user ' + this.user.name + '?', {
          color: '#f44336'
        })
        .then(confirm => {
          axios
            .delete(`api/v1/user/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'User deleted...',
                color: 'success'
              });
              this['User/fetchUsers']({ page: this.page });
              this.$router.push('/user');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.errorMessages = error.response.data.errors;
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/user/${this.$route.params.id}/edit`);
    }
  }
};
</script>